import { Reveal } from "./Reveal";

const stats = [
  { value: "80 %", label: "Reversés au photographe", sub: "sur chaque vente réalisée" },
  { value: "24 h", label: "Délai de reversement", sub: "après confirmation de vente" },
  { value: "1 800 €", label: "Revenu moyen mensuel", sub: "de nos photographes actifs" },
];

export default function Stats() {
  return (
    <section className="py-20 md:py-28 border-b border-[#E4E4E7]" data-testid="stats-section">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid md:grid-cols-3 gap-10 md:gap-6">
        {stats.map((s, i) => (
          <Reveal key={i} delay={i * 0.12}>
            <div className="border-l-2 border-[#F97316] pl-6">
              <div className="text-5xl md:text-6xl font-black tracking-tighter text-[#F97316]">{s.value}</div>
              <div className="mt-3 text-xs font-black uppercase tracking-label text-[#0A0A0A]">{s.label}</div>
              <div className="mt-1 text-sm text-[#52525B] font-light">{s.sub}</div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
